import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';
import TouchTooltip from '../../common/TouchTooltip';
import { fmtEur, fmtInt } from '../../../utils/buyerInsightsFormat';

// Column definitions per side (spec §2.3). `get` reads the value off a row, `fmt` formats it.
// Received revenue = the clicked items your partners' shoppers bought from you (approved orders).
// `revenue` false drops it (Sizes only you have: clicks and orders there are window-scoped).
export const columnsFor = (side, activeSort, { revenue = true } = {}) => {
  const cols = [];
  if (side !== 'sent') {
    cols.push(
      { key: 'received_clicks', group: 'Received', label: 'Clicks', tip: 'received clicks', get: (r) => r.received?.clicks },
      { key: 'received_orders', group: 'Received', label: 'Orders', tip: 'received orders', get: (r) => r.received?.orders }
    );
    if (revenue) {
      cols.push({
        key: 'received_revenue',
        group: 'Received',
        label: 'Revenue',
        tip: "received revenue: the clicked items your partners' shoppers bought from you",
        get: (r) => r.received?.revenue,
        fmt: fmtEur,
      });
    }
  }
  if (side !== 'received') {
    cols.push(
      { key: 'sent_matches', group: 'Sent', label: 'Matches shown', tip: 'sent matches shown', get: (r) => r.sent?.matches_shown },
      { key: 'sent_clicks', group: 'Sent', label: 'Clicks', tip: 'sent clicks', get: (r) => r.sent?.clicks },
      { key: 'sent_orders', group: 'Sent', label: 'Orders', tip: 'sent orders', get: (r) => r.sent?.orders }
    );
  }
  return cols.map((c, i) => ({
    fmt: fmtInt,
    ...c,
    active: c.key === activeSort,
    groupStart: i === 0 || cols[i - 1].group !== c.group, // draws the Received | Sent rule
  }));
};

// Received / Sent separation: a tinted band over each group and a rule down its first column.
const RULE = '2px solid #e0e0e0';
const BAND = '#f5f7f8';

export const numCellSx = (c) => ({
  whiteSpace: 'nowrap',
  px: 1.25,
  borderLeft: c.groupStart ? RULE : undefined,
  fontWeight: c.active ? 600 : 400,
  color: c.active ? 'text.primary' : 'text.secondary',
});

/** The two header rows' number part: group bands (Received, Sent) and sortable column labels. */
export const groupHeaderCells = (columns) => {
  const groups = [];
  columns.forEach((c) => {
    const last = groups[groups.length - 1];
    if (last && last.name === c.group) last.span += 1;
    else groups.push({ name: c.group, span: 1 });
  });
  return groups.map((g) => (
    <TableCell
      key={g.name}
      colSpan={g.span}
      align="center"
      sx={{ bgcolor: BAND, borderLeft: RULE, borderBottom: 'none', py: 0.75, fontWeight: 600, color: 'text.secondary', letterSpacing: 0.3 }}
    >
      {g.name}
    </TableCell>
  ));
};

export const columnHeaderCells = (columns, onSort) =>
  columns.map((c) => (
    <TableCell key={c.key} align="right" sx={{ whiteSpace: 'nowrap', px: 1.25, bgcolor: BAND, borderLeft: c.groupStart ? RULE : undefined }}>
      <TouchTooltip title={c.tip}>
        <TableSortLabel active={c.active} direction="desc" onClick={() => onSort(c.key)}>
          {c.label}
        </TableSortLabel>
      </TouchTooltip>
    </TableCell>
  ));
